'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
const typeFields_1 = require('../../typeFields');
function encode(data) {
  return {
    key: Buffer.from([typeFields_1.GlobalTypes.UNSIGNED_TX]),
    value: data.toBuffer(),
  };
}
exports.encode = encode;



//////////////////
// WEBPACK FOOTER
// ./node_modules/bip174/src/lib/converter/global/unsignedTx.js
// module id = NSnH
// module chunks = 6